import { get, post, put } from "@aiptyg/api-client";
import type { Action, Ad, ClickReport, Detail, Payload, Report, Slot } from "./model";
const base = "/v1/admin/advertising";
export function query(params: Record<string, string | number>) {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params))
    if (String(v) !== "") q.set(k, String(v));
  return q.toString();
}
export const listAds = (params: Record<string, string | number>) =>
  get<{ items: Ad[]; total: number }>(`${base}/ads?${query(params)}`);
export const getAd = (id: number) => get<Detail>(`${base}/ads/${id}`);
export const createAd = (payload: Payload) =>
  post<Ad>(`${base}/ads`, { agent_id: 0, payload });
export const updateAd = (ad: Ad, payload: Payload, change_note: string) =>
  put<Ad>(`${base}/ads/${ad.id}`, {
    payload,
    expected_version: ad.version,
    change_note,
  });
export const act = (ad: Ad, action: Action) =>
  post<Ad>(`${base}/ads/${ad.id}/actions`, {
    action,
    expected_version: ad.version,
  });
export const review = (
  ad: Ad,
  decision: "approved" | "rejected",
  note: string,
) =>
  post<Ad>(`${base}/ads/${ad.id}/review`, {
    revision_id: ad.current_revision_id,
    expected_version: ad.version,
    decision,
    note,
  });
export const slots = async () =>
  (await get<{ items: Slot[] }>(`${base}/slots`)).items;
export const updateSlot = (slot: Slot) =>
  put<Slot>(`${base}/slots`, {
    ...slot,
    version: undefined,
    expected_version: slot.version,
  });
export const report = (params: Record<string, string | number>) =>
  get<Report>(`${base}/reports?${query(params)}`);
export const clicks = (params: Record<string, string | number>) =>
  get<ClickReport>(`${base}/clicks?${query(params)}`);

export async function uploadCreative(file: File) {
  if (
    !["image/png", "image/jpeg", "image/webp", "image/gif"].includes(file.type)
  )
    throw new Error("请上传 PNG、JPEG、WebP 或 GIF 图片");
  if (file.size > 5 * 1024 * 1024) throw new Error("图片不能超过 5 MB");
  const [
    { buildConfig },
    { getAccessToken, handleUnauthorized },
    { signedHeaders },
  ] = await Promise.all([
    import("@aiptyg/config"),
    import("../../store/auth.store"),
    import("../tasks/services/tasks.service"),
  ]);
  const form = new FormData();
  form.append("file", file);
  form.append("name", file.name);
  const encoded = new Request("https://upload.invalid", {
    method: "POST",
    body: form,
  });
  const bytes = new Uint8Array(await encoded.arrayBuffer());
  const path = `${base}/creatives/upload`;
  const headers = await signedHeaders("POST", path, bytes, getAccessToken());
  headers["Content-Type"] = encoded.headers.get("Content-Type")!;
  const res = await fetch(`${buildConfig(import.meta.env).apiBaseUrl}${path}`, {
    method: "POST",
    headers,
    body: bytes as unknown as BodyInit,
    signal: AbortSignal.timeout(60000),
  });
  const data = await res.json();
  if (res.status === 401) handleUnauthorized();
  if (!res.ok)
    throw new Error(
      typeof data.error === "string"
        ? data.error
        : data.error?.code || "图片上传失败",
    );
  return data.item as { url: string };
}
